export const logoutNavigationMenu = {
  id: 'logout',
  title: 'logout',
  type: 'basic',
  icon: 'heroicons_outline:logout',
  link: '/auth/logout',
};

export const driverSettingsNavigationMenu = [
  {
    id: 'status',
    icon: 'heroicons_outline:flag',
    title: 'driverMenu.status',
    description: 'driverMenu.statusDescription',
    link: './status',
    securityFunctions: ['DRIVER_STATUS:read'],
    ignoreTranslation: false,
  },
  {
    id: 'personal',
    icon: 'heroicons_outline:user-circle',
    title: 'driverMenu.personal',
    description: 'driverMenu.personalDescription',
    link: './personal',
    securityFunctions: ['DRIVER_PERSONAL:read'],
    ignoreTranslation: false,
  },
  {
    id: 'licence',
    icon: 'heroicons_outline:identification',
    title: 'driverMenu.licence',
    description: 'driverMenu.licenceDescription',
    link: './licence',
    securityFunctions: ['DRIVER_LICENCE:read'],
    ignoreTranslation: false,
  },
  {
    id: 'authority',
    icon: 'heroicons_outline:shield-check',
    title: 'driverMenu.authority',
    description: 'driverMenu.authorityDescription',
    link: './authority',
    securityFunctions: ['DRIVER_AUTHORITY:read'],
    ignoreTranslation: false,
  },

  ///
  ///

  ////

  {
    id: 'business',
    icon: 'heroicons_outline:briefcase',
    title: 'driverMenu.business',
    description: 'driverMenu.businessDescription',
    link: './business',
    securityFunctions: ['DRIVER_DETAIL:read'],
    ignoreTranslation: false,
  },

  {
    id: 'billing',
    icon: 'heroicons_outline:document-text',
    title: 'driverMenu.billing',
    description: 'driverMenu.billingDescription',
    exactMatch: false,

    link: './billing',
    ignoreTranslation: false,
  },

  {
    id: 'remittance',
    icon: 'heroicons_outline:currency-dollar',
    title: 'driverMenu.remittance',
    description: 'driverMenu.remittanceDescription',
    link: './remittance-accounts',
    securityFunctions: ['DRIVER_REMITTANCE_ACCOUNTS:read'],
    ignoreTranslation: false,
  },

  ///

  ////
  ///
  ///
  ///
  {
    id: 'conditions',
    icon: 'heroicons_outline:clipboard-list',
    title: 'driverMenu.conditions',
    description: 'driverMenu.conditionsDescription',
    link: './conditions',
    securityFunctions: ['DRIVER_CONDITIONS:read'],
    ignoreTranslation: false,
  },

  {
    id: 'certificate',
    icon: 'heroicons_outline:document-report',
    title: 'driverMenu.certificate',
    description: 'driverMenu.certificateDescription',
    link: './certificate',
    securityFunctions: ['DRIVER_CERTIFICATE:read'],
    ignoreTranslation: false,
  },

  {
    id: 'integration',
    icon: 'link',
    title: 'driverMenu.integration',
    description: 'driverMenu.integrationDescription',
    link: './integration',
    securityFunctions: ['DRIVER_INTEGRATION_LINK:read'],
    ignoreTranslation: false,
  },

  {
    id: 'history',
    icon: 'heroicons_outline:collection',
    title: 'driverMenu.history',
    description: 'driverMenu.historyDescription',
    link: './history',
    securityFunctions: ['DRIVER_RECORD:read'],
    ignoreTranslation: false,
  },

  ////
  ////
  ///
  ///

  {
    id: 'terminal',
    icon: 'heroicons_outline:device-mobile',
    title: 'driverMenu.terminal',
    description: 'driverMenu.terminalDescription',
    link: './terminal',
    securityFunctions: ['DRIVER_ASSET:read'],
    ignoreTranslation: false,
  },

  {
    id: 'security',
    icon: 'heroicons_outline:lock-closed',
    title: 'driverMenu.security',
    description: 'driverMenu.securityDescription',
    link: './security',
    securityFunctions: ['DRIVER_SECURITY_PREFERENCES:read'],
    ignoreTranslation: false,
  },

  {
    id: 'diagnostic',
    icon: 'heroicons_outline:chart-square-bar',
    title: 'driverMenu.diagnostic',
    description: 'driverMenu.diagnosticDescription',
    link: './diagnostic',
    securityFunctions: ['DRIVER_DIAGNOSTICS:read'],
    ignoreTranslation: false,
  },
];

export const driverSettingsNavigationForMainMenu =
  driverSettingsNavigationMenu.map((navItem: any) => {
    return {
      ...navItem,
      link: 'driver/settings' + navItem.link.replace('.', ''),
      type: 'basic',
    };
  });
